import React from "react";
import './Avatar.scss';

const Avatar = ({ label, className, size = 'medium', src, alt }) => {
    const formatearLabel = (label) => {
        if (!label) return null;
        const palabras = label.trim().split(/\s+/);
        if (palabras.length === 1) return palabras[0].slice(0, 2).toUpperCase();
        if (palabras.length === 2) return `${palabras[0][0]}${palabras[1][0]}`.toUpperCase();
        return `${palabras[0][0]}${palabras[2][0]}`.toUpperCase();
    }
    return (
        <div className={`Avatar ${className || ''} ${size}`}>
            {label && !src && <div className="Avatar-label">{formatearLabel(label)}</div>}
            {src && <img src={src} alt={alt || label} className={`Avatar-image ${size}`} />}
        </div>
    );
}
export default Avatar;